"use strict";

var _regeneratorRuntime = require("C:\\GitsRespositories\\PlayerEngagement\\Source\\PlayerEngagementApi\\player-engagement-app\\node_modules\\@babel\\runtime/regenerator");

var _asyncToGenerator = require("C:\\GitsRespositories\\PlayerEngagement\\Source\\PlayerEngagementApi\\player-engagement-app\\node_modules\\@babel\\runtime/helpers/asyncToGenerator");

var _require = require("idb-keyval"),
    get = _require.get,
    set = _require.set,
    del = _require.del;

var isCacheAvailable =
/*#__PURE__*/
function () {
  var _ref = _asyncToGenerator(
  /*#__PURE__*/
  _regeneratorRuntime.mark(function _callee(url) {
    var item;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.prev = 0;
            _context.next = 3;
            return get("loader_".concat(url));

          case 3:
            item = _context.sent;

            if (item) {
              _context.next = 6;
              break;
            }

            return _context.abrupt("return");

          case 6:
            item = JSON.parse(item);

            if (!(Date.now() < item.expiry)) {
              _context.next = 11;
              break;
            }

            return _context.abrupt("return", item.data);

          case 11:
            del("loader_".concat(url));
            return _context.abrupt("return");

          case 13:
            _context.next = 18;
            break;

          case 15:
            _context.prev = 15;
            _context.t0 = _context["catch"](0);
            return _context.abrupt("return");

          case 18:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, null, [[0, 15]]);
  }));

  return function isCacheAvailable(_x) {
    return _ref.apply(this, arguments);
  };
}();

var setCache = function setCache(url, data, cacheOpt) {
  var cacheExp = parseInt(cacheOpt, 10);

  try {
    set("loader_".concat(url), JSON.stringify({
      data: data,
      expiry: Date.now() + (Number.isNaN(cacheExp) ? 60 * 60 * 1000 * 24 : cacheExp)
    }));
  } catch (e) {
    return;
  }
};

var renderBody = function renderBody(elem, body) {
  var parser = new DOMParser();
  var doc = parser.parseFromString(body, "text/html");
  var fragment = doc.querySelector("svg"); // When svg-loader is loading in the same element, it's
  // important to keep track of original properties.

  var elemAttributesSet = elem.getAttribute("data-attributes-set");
  var attributesSet = elemAttributesSet ? new Set(elemAttributesSet.split(",")) : new Set();

  for (var i = 0; i < fragment.attributes.length; i++) {
    var _fragment$attributes$ = fragment.attributes[i],
        name = _fragment$attributes$.name,
        value = _fragment$attributes$.value; // Don't override the attributes already defined, but override the ones that
    // were in the original element

    if (!elem.getAttribute(name) || attributesSet.has(name)) {
      attributesSet.add(name);
      elem.setAttribute(name, value);
    }
  }

  elem.setAttribute("data-attributes-set", Array.from(attributesSet).join(","));
  elem.setAttribute("data-rendered", true);
  elem.innerHTML = fragment.innerHTML;
};

var requestsInProgress = {};
var memoryCache = {};

var renderIcon =
/*#__PURE__*/
function () {
  var _ref2 = _asyncToGenerator(
  /*#__PURE__*/
  _regeneratorRuntime.mark(function _callee2(elem) {
    var src, cacheOpt, lsCache, isCachingEnabled, cache;
    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            src = elem.getAttribute("data-src");
            cacheOpt = elem.getAttribute("data-cache");
            _context2.next = 4;
            return isCacheAvailable(src);

          case 4:
            lsCache = _context2.sent;
            isCachingEnabled = cacheOpt !== "disabled"; // Memory cache optimizes same icon requested multiple
            // times on the page

            if (!(memoryCache[src] || isCachingEnabled && lsCache)) {
              _context2.next = 11;
              break;
            }

            cache = memoryCache[src] || lsCache;
            renderBody(elem, cache);
            _context2.next = 16;
            break;

          case 11:
            if (!requestsInProgress[src]) {
              _context2.next = 14;
              break;
            }

            setTimeout(function () {
              return renderIcon(elem);
            }, 20);
            return _context2.abrupt("return");

          case 14:
            requestsInProgress[src] = true;
            fetch(src).then(function (body) {
              return body.text();
            }).then(function (body) {
              if (isCachingEnabled) {
                setCache(src, body, cacheOpt);
              }

              memoryCache[src] = body;
              renderBody(elem, body);
            }).finally(function () {
              delete requestsInProgress[src];
            });

          case 16:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  }));

  return function renderIcon(_x2) {
    return _ref2.apply(this, arguments);
  };
}();

var intObserver = new IntersectionObserver(function (entries) {
  entries.forEach(function (entry) {
    if (entry.isIntersecting) {
      renderIcon(entry.target); // Unobserve as soon as soon the icon is rendered

      intObserver.unobserve(entry.target);
    }
  });
}, {
  // Keep high root margin because intersection observer 
  // can be slow to react
  rootMargin: "1200px"
});
var handled = [];

function renderAllSVGs() {
  Array.from(document.querySelectorAll("svg[data-src]:not([data-rendered])")).forEach(function (element) {
    if (handled.indexOf(element) !== -1) {
      return;
    }

    handled.push(element);

    if (element.getAttribute("data-loading") === "lazy") {
      intObserver.observe(element);
    } else {
      renderIcon(element);
    }
  });
}

var observerAdded = false;

var addObservers = function addObservers() {
  if (observerAdded) {
    return;
  }

  observerAdded = true;
  var observer = new MutationObserver(function (mutationRecords) {
    var shouldTriggerRender = mutationRecords.some(function (record) {
      return Array.from(record.addedNodes).some(function (elem) {
        return elem.nodeType === Node.ELEMENT_NODE && (elem.getAttribute("data-src") && !elem.getAttribute("data-rendered") || elem.querySelector("svg[data-src]:not([data-rendered])"));
      });
    }); // If any node is added, render all new nodes

    if (shouldTriggerRender) {
      renderAllSVGs();
    } // If data-src is changed, re-render


    mutationRecords.forEach(function (record) {
      if (record.type === "attributes") {
        renderIcon(record.target);
      }
    });
  });
  observer.observe(document.documentElement, {
    attributeFilter: ["data-src"],
    attributes: true,
    childList: true,
    subtree: true
  });
}; // Start rendering SVGs as soon as possible


var intervalCheck = setInterval(function () {
  renderAllSVGs();
}, 100);
window.addEventListener("DOMContentLoaded", function () {
  clearInterval(intervalCheck);
  renderAllSVGs();
  addObservers();
});